import { Tag } from "antd";
import styled, { css } from "styled-components";
import { theme } from "../../../../theme";

const { CheckableTag } = Tag;

const CheckTag = styled(CheckableTag)<{
  disabled?: boolean;
  $block?: boolean;
}>`
  &.ant-tag-checkable {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0;
    gap: 10;

    padding: 8px 10px;
    flex: 1 0 0;

    border: 1px solid ${theme.colors.gray6};
    border-radius: 6px;

    ${({ $block }) => ($block ? theme.typo.body.r16 : theme.typo.body.r12)};
    color: ${theme.colors.gray1};

    ${({ disabled }) =>
      disabled &&
      css`
        background: ${theme.colors.gray9};
        border: 1px solid ${theme.colors.gray9};
        color: ${theme.colors.gray6};
        pointer-events: none;
      `}

    &:hover, &:active {
      opacity: 0.8;
      background: transparent;
      color: ${theme.colors.gray1};
      border: 1px solid ${theme.colors.gray1};
    }
    &.ant-tag-checkable-checked {
      background: ${theme.colors.red6};
      border: 1px solid ${theme.colors.red6};
      color: ${theme.colors.red3};
    }
  }
`;

export { CheckTag };
